module.exports = __webpack_public_path__ + "images/accents/accent-review-resolve@1x-f2cebb2f12a86b78458decf314a04ac6.webp";